// import { MobileOS } from '@quadminds/shared/commons';
import { MobileApplicationType, TrackerType } from '../types';

export interface MobileAppMetadata {
    appVersion?: string; // App version string number
    appName?: MobileApplicationType; // "driver_app" | "stork_supervisor_app" | "stork_driver_app"
    osVersion?: string; // OS version string number
    deviceModel?: string;
    batteryLevel?: number; // Battery level in percentage
    locationPermission?: boolean; // Location permission status
    accuracy?: number; // in meters (mobile only)
    speedAccuracy?: number; // in meters per second (mobile only)
}

export interface GPSTrackingDeviceMetadata {
    firmwareVersion?: string;
    trackerDeviceType?: TrackerType;
    signalStrength?: number;
    satelliteCount?: number;
    batteryLevel?: number;
    temperature?: string; // Temperature value
}
